import { useState } from "react";
import { H3, Label } from "../Text";
import { toast } from "react-toastify";
import Circle from "../Animation/Circle";
import { Button } from "../Buttons";
import { Request } from "../../hooks/Request";
import TableComplete from "../Tables/TableComplete";
import { requestAuth } from "../services/RequestService";
import { useDialog } from "../../contexts/DialogContext";
import { DialogConfirmation } from "../Modal";
import CreatableSelect from "react-select/creatable";
import { validateArray } from "../../utils/validate";
import { FormDetailsDocument } from "./FormDetailsDocument";

const InputSubDepositReconciliation = ({ field }) => {
  const { openDialog, dialogClose } = useDialog();

  const { data, loading, call } = Request({
    urlApi: `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
  });
  const {
    data: document,
    loading: loadDocument,
    call: callDocument,
  } = Request({
    urlApi: field.urlApi,
  });

  function handleForm(item) {
    openDialog(
      <>
        {loadDocument && (
          <div className="min-h-[360px]">
            <FormAddDocument
              data={document}
              item={item}
              reload={call}
              field={field}
              onClose={dialogClose}
              callDocument={callDocument}
            />
          </div>
        )}
      </>
    );
  }

  function handleFormItems(item) {
    openDialog(
      <>
        {loadDocument && (
          <div className="">
            <FormDetailsDocument
              // data={document}
              item={item}
              reload={call}
              // field={field}
              onClose={dialogClose}
              // callDocument={callDocument}
            />
          </div>
        )}
      </>
    );
  }

  function handleDelete(data) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar este item?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`/dataSet/procedure/subData/${data.id}`}
        texBtn="Eliminar"
        handleSuccess={call}
      />
    );
  }

// Segun el PDF |
// const processDataWithSaldo = (rawData) => {
//   let saldoAcumulado = 0;

//   return rawData.map((item, index) => {
//     const monto = parseFloat(item.description3) || 0;
//     const tipo = item.description2?.toLowerCase().trim();

//     // Primer fila: copiar el saldo 
//     if (index === 0) {
//       saldoAcumulado = tipo === "egreso" ? monto : -monto;
//     } else {
//       // Filas siguientes: aplicar lógica de saldo del PDF
//       if (tipo === "ingreso") {
//         // Si el PDF muestra ingreso como negativo, se resta
//         saldoAcumulado -= monto; 
//       } else if (tipo === "egreso") {
//         // Si el PDF muestra egreso como positivo, se suma
//         saldoAcumulado += monto; 
//       }
//     }

//     return {
//       ...item,
//       monto,
//       saldoCalculado: saldoAcumulado
//     };
//   });
// };

// Estado de resultados
const processDataWithSaldo = (rawData) => {
  let saldoAcumulado = 0;

  return rawData.map((item) => {
    const monto = parseFloat(item.description3) || 0;
    const tipo = item.description2?.toLowerCase().trim();
    
    if (tipo === "ingreso") {
      saldoAcumulado += monto;
    } else if (tipo === "egreso") {
      saldoAcumulado -= monto;
    }

    return {
      ...item,
      monto,
      saldoCalculado: saldoAcumulado,
    };
  });
};


const dataWithSaldo = processDataWithSaldo(data || []);

  return (
    <div className="bg-gray-300/40 p-2 rounded-md">
      <Label htmlFor={field.name} className={`${field.className} my-0`}>
        {field.labelCustom ? field.labelCustom : field.label}
      </Label>
      <div className="bg-gray-100 rounded-lg p-3 pt-2">
        {loadDocument && (
          <FormAddDocument
            data={document}
            reload={call}
            field={field}
            onClose={() => {}}
            callDocument={callDocument}
          />
        )}
      </div>
      <br />
      {!loading ? (
        <Circle />
      ) : (
        <div className="w-full">
          <TableComplete
            header={[
              
              {
                name: "description",
                label: "Fecha",
              },
              {
                name: "label",
                label: "Descripcion",
              },
              
              {
                name: "ingreso",
                label: "Ingreso (Debe)",
                type: "custom",
                builder: (value, head, data) => {
                  if (data.description2?.toLowerCase() === "ingreso") {
                    const monto = parseFloat(data.description3) || 0;
                    return (
                      <span className="text-green-600 font-semibold">
                        {monto.toLocaleString('es-BO', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                      </span>
                    );
                  }
                  return <span className="text-gray-400">-</span>;
                }
              },
              {
                name: "egreso",
                label: "Egreso (haber)", 
                type: "custom",
                builder: (value, head, data) => {
                  if (data.description2?.toLowerCase() === "egreso") {
                    const monto = parseFloat(data.description3) || 0;
                    return (
                      <span className="text-red-600 font-semibold">
                        {monto.toLocaleString('es-BO', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                      </span>
                    );
                  }
                  return <span className="text-gray-400">-</span>;
                }
              },
              {
                name: "saldo",
                label: "Saldo",
                type: "custom",
                builder: (value, head, data) => {
                  const saldo = data.saldoCalculado || 0;
                  return (
                    <span className={saldo >= 0 ? "text-green-600 font-semibold" : "text-red-600 font-semibold"}>
                      {saldo.toLocaleString('es-BO', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </span>
                  );
                }
              },
              {
                name: "add",
                type: "action",
                label: "Opciones",
                sticky: true,
                actions: [
                  {
                    label: "Editar",
                    icon: "fas  fa-edit",
                    action: handleForm,
                    color: "text-[#1d4ed8]",
                  },
                  {
                    label: "Añadir",
                    icon: "fas fa-trash",
                    action: handleDelete,
                    color: "text-red-500",
                  },
                ],
              },
              
            ]}
            data={dataWithSaldo}
          />
        </div>
      )}
    </div>
  );
};

const FormAddDocument = (props) => {
  const { data, item = null, reload, field, onClose, callDocument } = props;
  const [values, setValues] = useState({
    Label: item?.label ? item.label : "",
    NumberValue: item?.numberValue ? item.numberValue : 0,
    Description: item?.description ? item.description : "",
    Description2: item?.description2 ? item.description2 : "",
    Description3: item?.description3 ? item.description3 : "",
    Description4: item?.description4 ? item.description4 : "",
    Description5: item?.description5 ? item.description5 : "",
    isNew: false,
  });

  async function handleSubmit() {
    if (values.isNew) {
      await handleCreateOption(values);
    }
    await requestAuth(
      item ? "put" : "post",
      item
        ? `/dataSet/procedure/subData/${item.id}`
        : `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
      item
        ? {
            ...values,
          }
        : {
            ...values,
          }
    )
      .then(() => {
        reload();
        onClose();
        setValues({
          ...values,
          NumberValue: 0,
          Description: "",
          Description2: "",
        });
        toast.success("Registro exitoso");
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }

  async function handleCreateOption(value) {
    await requestAuth("post", "/Dropdown/Option", {
      Name: value.Label,
      DropdownListLabel: field.urlInitial,
    }).then(() => {
      callDocument();
    });
  }

  function handleChangeInp(e) {
    const { name, value } = e.target;
    setValues((a) => ({
      ...a,
      [name]: value,
    }));
  }
  function handleChange(e) {
  setValues((a) => ({
    ...a,
    Description2: e.value,
    isNew: e.__isNew__ || false,
  }));
}

  return (
    <form className="flex flex-col">
      <Label className={`mt-2`}>Description</Label>
      <input
        value={values.Label}
        onChange={handleChangeInp}
        className="w-full p-2 rounded-md"
        type="text"
        name="Label"
      />
      <Label className={`mt-2`}>Fecha</Label>
      <input
        value={values.Description}
        onChange={handleChangeInp}
        className="w-full p-2 rounded-md"
        type="date"
        name="Description"
      />
      <Label className={`mt-2`}>Tipo</Label>
        <CreatableSelect
          onChange={handleChange} 
          styles={{
            placeholder: (base) => ({
              ...base,
              color: "black",
            }),
          }}
          placeholder={"Seleccionar..."}
          isOptionSelected={false}
          options={[{value:"egreso",label:"Egreso"},{value:"ingreso",label:"Ingreso"}]} 
          value={values.Description2 ? {value: values.Description2, label: values.Description2} : null} 
        />
      <Label className={`my-0 mt-4`}>{item ? "Monto proforma" : "Monto"}</Label>
      <div className={`flex gap-2 ${item ? "flex-col" : ""}`}>
        <input
          value={values.Description3}
          onChange={handleChangeInp}
          className="w-full p-2 rounded-md"
          type="number"
          name="Description3"
        />
        <Button
          onClick={handleSubmit}
          className={`px-3 ${item ? "mt-2 py-3" : "py-0"}`}
        >
          Guardar
        </Button>
      </div>
    </form>
  );
};

export default InputSubDepositReconciliation;
